export default __webpack_public_path__ + "static/Entenda0153-bcb7f43d1847ac7e47c0870286ea1cfa.jpg";